import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const FlagListingModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "FlagListingModalContainer" */
      './FlagListingModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
